export interface IconProps {
  width?: number;
  height?: number;
}

export default function LinkAttachIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
    >
      <path
        fill="currentColor"
        d="M1.3 13.7a4.458 4.458 0 010-6.3l1.09-1.087a.469.469 0 01.8.311 1.97 1.97 0 00.166.935.473.473 0 01-.11.487l-.384.383a2.538 2.538 0 00-.547 3.749 2.8 2.8 0 003.89.26l2.16-2.176a2.385 2.385 0 00-.122-3.483 2.152 2.152 0 00-.3-.25.53.53 0 01-.2-.369c-.012-.31-.035-.417.209-.661l.418-.519a.47.47 0 01.6-.051 5.263 5.263 0 01.6.5 4.45 4.45 0 01.01 6.287l-.01.011L7.6 13.7a4.458 4.458 0 01-6.3 0zm4.73-3.625a5.449 5.449 0 01-.6-.5 4.45 4.45 0 01-.01-6.292l.011-.011L7.4 1.3a4.453 4.453 0 016.3 6.3l-1.09 1.087a.468.468 0 01-.8-.311 2 2 0 00-.166-.934.473.473 0 01.111-.487l.384-.383a2.538 2.538 0 00.547-3.749 2.8 2.8 0 00-3.891-.259l-2.16 2.175a2.384 2.384 0 00.12 3.482 2.354 2.354 0 00.3.251.526.526 0 01.2.369c.012.309.035.416-.209.66l-.418.52a.465.465 0 01-.33.136.475.475 0 01-.266-.085z"
        data-name="Union 26"
      ></path>
    </svg>
  );
}
